import React from "react";
import dummyImage from "../../assets/dummyPreview.png";
import styles from "./productImages.module.css";

export const ProductImages = ({ images = [], productName = "Product" }) => {
  if (!images?.length) return null;

  return (
    <section
      className={styles.wrapper}
      aria-labelledby="product-images-heading"
    >
      <div className={styles.container}>
        <h2 id="product-images-heading" className={styles.heading}>
          Images
        </h2>

        <div className={styles.grid}>
          {images.map((img, index) => (
            <article key={index} className={styles.card}>
              <img
                src={img?.image_url || dummyImage}
                alt={`${productName} ${index + 1}`}
                loading="lazy"
                className={styles.image}
                onError={(e) => {
                  e.currentTarget.onerror = null; // prevent infinite loop
                  e.currentTarget.src = dummyImage;
                }}
              />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};